<ngx-editor
	[editor]="editor"
	[ngModel]="html"
	(ngModelChange)="htmlHasChanged($event)"
	[placeholder]="placeholder"
	[disabled]="disabled"
	[spellcheck]="false">
</ngx-editor>